module.exports = __webpack_public_path__ + "media/images/icons/tick-white-no-border-2855c9a46780bbd2a0a8cebccdfcf2f4.svg";